import { getCookie } from '../http/cookie';

class State {
    private _locale: string = getCookie('locale')?.toString() || navigator.language.split('-')[0] || 'zh';

    set locale(loc: string) {
        this._locale = loc;
    }

    get locale() {
        return this._locale;
    }
}

export default new State;
